// extracted by mini-css-extract-plugin
export default {"format":"Dropdown_format__9waQk","name":"Dropdown_name__mPZ2Q","icon":"Dropdown_icon__XLPg9"};